import {
    createContext, useContext, useReducer, useMemo,
} from 'react';
import { getUserDevice } from '../utils/getUserDevice';
import { setCookie } from '../utils/cookieUtils';

// TODO: change all context file type to js
export const HeaderContext = createContext(null);

export const useHeaderContext = () => {
    return useContext(HeaderContext);
};

const initialState = {
    isShowLoginPopup: false,
    language: 'en',
    isShowRightNav: false,
    isCloseButtonVisible: true,
    isShowUMPopup: false,
    isShowCopySiteWarningPopup: false,
};

const init = ({
    isShowLoginPopup, language, isShowRightNav, isCloseButtonVisible, isShowUMPopup, isShowCopySiteWarningPopup,
}) => {
    return {
        isShowLoginPopup,
        platform: (typeof window !== 'undefined' && getUserDevice()) || 'desktop',
        language,
        isShowRightNav,
        isCloseButtonVisible,
        isShowUMPopup,
        isShowCopySiteWarningPopup,
    };
};

const headerReducer = (state, action) => {
    switch (action.type) {
    case 'SHOW_LOGIN_POPUP':
        return { ...state, isShowLoginPopup: !state.isShowLoginPopup };
    case 'CHANGE_PLATFORM':
        switch (action.value) {
        case 'downloadapp':
            return { ...state };
        case 'wap':
            return { ...state };
        default:
            setCookie('LOGIN_PLATFORM', action.value, 3650);
            return { ...state, platform: action.value };
        }
    case 'CHANGE_LANGUAGE':
        return { ...state, language: action.value };
    case 'CHANGE_DEVICE':
        return { ...state, device: action.value };
    case 'TOGGLE_RIGHT_NAV_SHOWING':
        return { ...state, isShowRightNav: action.value };
    case 'UPDATE_LOGIN_ENTER_POINT':
        return { ...state, enterPoint: action.value };
    case 'TOGGLE_SHOWING_MEMBER_RULES':
        return { ...state, isShowMemberRules: action.value };
    case 'SET_IS_CLOSE_BUTTON_VISIBLE':
        return { ...state, isCloseButtonVisible: action.value };
    case 'SHOW_UM_POPUP':
        return { ...state, isShowUMPopup: !state.isShowUMPopup };
    case 'SHOW_COPYSITE_WARNING_POPUP':
        return { ...state, isShowCopySiteWarningPopup: true };
    case 'HIDE_COPYSITE_WARNING_POPUP':
        return { ...state, isShowCopySiteWarningPopup: false };
    default:
        return state;
    }
};

export const HeaderProvider = ({ children }) => {
    const [state, dispatch] = useReducer(
        headerReducer,
        initialState,
        init,
    );

    const contextValue = useMemo(() => [state, dispatch], [state, dispatch]);

    return (
        <HeaderContext.Provider value={contextValue}>
            {children}
        </HeaderContext.Provider>
    );
};
